export default {
  title: "Frequently asked questions",
  subtitle: "Answers to the most common questions about using the platform.",
  contactNote: "If your question isn't answered here, write to us at",
  categories: {
    all: "All",
    cuenta: "Account & access",
    wallet: "Wallet & security",
    ine: "INE verification",
    candidatura: "Candidacy",
    suscripcion: "Membership & billing",
    soporte: "Technical support",
  },
}
